import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ContactGuide() {
  const { t } = useTranslation();
  return (
    <section className="relative py-16 md:py-20 bg-background-100/50">
      <div className="max-w-[700px] mx-auto px-8 text-center">
        <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
          CONTACT
        </p>
        <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
          {t('association.contact.title')}
        </h2>
        {String(t('association.contact.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
        <div className="gold-line mx-auto mb-6"></div>
        {String(t('association.contact.body')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[550px] mx-auto mb-8">{__s}</p>))}

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="inline-block px-10 py-3.5 bg-accent-500 hover:bg-accent-400 text-primary-900 text-[15px] tracking-[0.1em] font-medium transition-all duration-300 whitespace-nowrap cursor-pointer btn-glow w-full sm:w-auto text-center"
          >
            {t('association.contact.ctaContact')}
          </Link>
          <Link
            to="/brochure"
            className="inline-block px-10 py-3.5 border border-accent-500/30 text-accent-600 hover:bg-accent-500/10 text-[15px] tracking-[0.08em] transition-all duration-300 whitespace-nowrap w-full sm:w-auto text-center"
          >
            {t('association.contact.ctaBrochure')}
          </Link>
        </div>
      </div>
    </section>
  );
}
